export default __webpack_public_path__ + "static/media/reviewGirls.a5bf3e6d.jpg";